import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      appbar: false
    }
  },
  {
    path: '/start',
    name: 'Start',
    component: () => import(/* webpackChunkName: "start" */ '../views/Start.vue'),
    meta: {
      appbar: true
    }
  },
  {
    path: '/explainable/:id',
    name: 'Explainable',
    component: () => import(/* webpackChunkName: "explainable" */ '../views/Explainable.vue'),
    meta: {
      appbar: true
    }
  },
  {
    path: '/optimization/:id',
    name: 'Optimization',
    component: () => import(/* webpackChunkName: "optimization" */ '../views/Optimization.vue'),
    meta: {
      appbar: true
    }
  },
  {
    path: '/download/:id',
    name: 'Download',
    component: () => import(/* webpackChunkName: "optimization" */ '../views/Download.vue'),
    meta: {
      appbar: true
    }
  },
  {
    path: '/:pathMatch(.*)*',
    component: () => import(/* webpackPrefetch: true */ '../views/PageNotFound.vue'),
    meta: {
      appbar: true
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.afterEach(( to ) => {
  window.gtag('send', 'page_view', {
    page_title: to.name,
    page_path: to.path
  })
})
export default router
